import api, { formatApiError } from "../../lib/api";
import { fmtDateTimeParis } from "../../lib/date";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import EventFormDialog from "./EventFormDialog";

export default function EventsPanel({ events, onReload }) {
  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-display text-2xl">Événements</h2>
        <EventFormDialog onSaved={onReload} />
      </div>
      <div className="space-y-3">
        {events.map((e) => (
          <div
            key={e.id}
            className="rounded-xl border border-border bg-card p-5 flex justify-between items-center gap-3"
            data-testid={`admin-event-${e.id}`}
          >
            <div className="flex items-center gap-4 min-w-0 flex-1">
              {e.image && (
                <img src={e.image} alt={e.title} className="h-14 w-14 object-cover rounded-lg border border-border shrink-0" />
              )}
              <div className="min-w-0">
                <div className="font-display text-xl truncate">{e.title}</div>
                <div className="text-sm text-muted-foreground">
                  {fmtDateTimeParis(e.date)} · {e.seats_available}/{e.seats_total} places · {e.price.toFixed(0)}€
                </div>
              </div>
            </div>
            <div className="flex items-center gap-1 shrink-0">
              <EventFormDialog event={e} onSaved={onReload} />
              <Button
                variant="ghost"
                size="icon"
                onClick={async () => {
                  if (!window.confirm("Supprimer cet événement ?")) return;
                  try {
                    await api.delete(`/admin/events/${e.id}`);
                    toast.success("Supprimé");
                    onReload();
                  } catch (err) {
                    toast.error(formatApiError(err.response?.data?.detail));
                  }
                }}
                data-testid={`delete-event-${e.id}`}
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
